module.exports = __webpack_public_path__ + "img/rs.55d796a6.svg";